import React, { useContext } from 'react';
import classes from '../TableContainer/index.module.scss';
import { SearchContext } from '../../context/Search';
import moment from 'moment';

const REFACTORING_OBJECT_CONTRACT_OPPORTUNITY = {
  contacts: item => item.map(contact => Object.values(contact).filter(item => item).join(', ')).filter(item => item).join('; '),
  description: item => <div dangerouslySetInnerHTML={{__html: item}} />,
  office_address: item => Object.values(item).filter(item => item).join(', '),
  sam_link: item => <a href={item} target="_blank">{item}</a>
}

const REFACTORING_OBJECT_B2B = {
  link: item => item ? <a href={item} target="_blank">{item}</a> : "N/A",
  setaside_code: item => item ? item.join(', ') : "N/A"
}

const REFACTORING_OBJECT_PURCHASES = {
  link: item => item ? <a href={item} target="_blank">{item}</a> : "N/A",
}

const REFACTORING_OBJECT_BUSINESSES = {
  keywords: item => item ? item.join(', ') : "N/A",
  naics: item => item ? item.join(', ') : "N/A",
  link: item => item ? <a href={item} target="_blank">{item}</a> : "N/A",
  email: item => item ? <a href={`mailto:${item}`}>{item}</a> : "N/A",
  phone: item => item ? <a href={`tel:${item}`}>{item}</a> : "N/A",
}

const REFACTORING_OBJECT_OFFICER = {};

const REFACTORING_OBJECT_USER = {
  is_active: item => item ? "Active" : "Disabled",
  registration_date: item => moment(item).format('YYYY-MM-DD')
}

const REFACTORING_OBJECT = {
  contract_opportunities_reports: REFACTORING_OBJECT_CONTRACT_OPPORTUNITY,
  b2b_opportunities_reports: REFACTORING_OBJECT_B2B,
  purchases_reports: REFACTORING_OBJECT_PURCHASES,
  businesses_reports: REFACTORING_OBJECT_BUSINESSES,
  contract_officers: REFACTORING_OBJECT_OFFICER,
  users: REFACTORING_OBJECT_USER
}

const TableBody = () => {
  const { searchedData, headerParams, active } = useContext(SearchContext);
  
  const refactoringData = (entity, key, value, data) => {
    if (key === "role_description") {
      return data[0].role_description.charAt(0).toUpperCase() + data[0].role_description.slice(1);
    }

    if (!Object.keys(REFACTORING_OBJECT[entity]).includes(key)) {
      return value;
    } 

    return REFACTORING_OBJECT[entity][key](value);
  }

  return (
    <>
      {
        searchedData.map(sItem => {
          return (
            <tr 
              key={sItem.id}
            >
              {headerParams.map(hItem => {
                return (
                  <td className={classes.Title_Normal}>{refactoringData(active, hItem, sItem[hItem], sItem.roles) || "N/A"}</td>
                )
              })}
            </tr>
          )
        })
      }
    </>
  )
}

export default TableBody;